export default __webpack_public_path__ + "static/media/01.b45e4e81.jpg";